import styled, { css } from 'styled-components';

export const dF = css`
  display: flex;
`;

export const dIF = css`
  display: inline-flex;
`;

export const flexWrap = css`
  flex-wrap: wrap;
`;

export const flex1 = css`
  flex: 1;
`;

export const flex2 = css`
  flex: 2;
`;

export const flexCol = css`
  display: flex;
  flex-direction: column;
`;

export const textAlignLeft = css`
  text-align: left;
`;

export const textAlignCenter = css`
  text-align: center;
`;

export const textAlignRight = css`
  text-align: right;
`;

export const justifyCenter = css`
  justify-content: center;
`;

export const justifyStart = css`
  justify-content: flex-start;
`;

export const justifyEnd = css`
  justify-content: flex-end;
`;

export const justifyBetween = css`
  justify-content: space-between;
`;

export const justifyAround = css`
  justify-content: space-around;
`;

export const alignItemsCenter = css`
  align-items: center;
`;

export const alignItemsStart = css`
  align-items: flex-start;
`;

export const alignItemsEnd = css`
  align-items: flex-end;
`;

export const alignItemsBaseline = css`
  align-items: baseline;
`;

export const alignItemsStretch = css`
  align-items: stretch;
`;

export const alignSelfStart = css`
  align-self: flex-start;
`;

export const alignSelfCenter = css`
  align-self: center;
`;

export const fGS0 = css`
  flex-grow: 0;
  flex-shrink: 0;
`;

export const quicks = css`
  font-family: 'Quicksand';
  font-weight: 500;
`;

export const op06 = css`
  opacity: 0.6;
`;

export const baseInputStyles = css`
  border: 1px solid ${({ error }) => (error ? `red` : `green`)};
  border-radius: 4px;
  outline: none;
  padding: 0.5em;
`;

export const DefaultInput = styled.input`
  ${baseInputStyles}
`;

export const SecondComponent = styled.button`
  ${baseInputStyles}/* make changes as needed*/
`;

export const flexObj = {
  dIF,
  flexWrap,
  flex1,
  dF,
  flexCol,
  justifyCenter,
  justifyStart,
  justifyEnd,
  justifyBetween,
  justifyAround,
  alignItemsCenter,
  alignItemsStart,
  alignItemsEnd,
  alignItemsBaseline,
  alignItemsStretch,
  alignSelfStart,
  alignSelfCenter,
  fGS0,
  op06,
  quicks,
  textAlignLeft,
  textAlignCenter,
  textAlignRight
};
